<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap>
                                  <v-col cols="12">
                                      <h2>Edit Rooms, Rates and Guests</h2>
                                  </v-col>

                                    <v-col cols="12">
                                        <h2>Units ({{ units.length }})</h2>
                                        <p>Room Type Editor - note that this does save the basic information, but not the breakdown per date yet nor cancellation policies or taxes/fees</p>
                                        <p>All prices are in {{ reservation.hotel.hotel_name }}'s local currency {{ reservation.hotel.currency.currency_name }}</p>
                                    </v-col>

                                    <v-col cols="12">
                                       <div v-for="(unit, index) in units">
                                       <fieldset>
                                           <legend>Unit {{ (index + 1)}}</legend>
                                               <v-layout row>
                                                <v-col cols="12"><h3>Room, Rate and Guests</h3></v-col>


                                           <v-col cols="12" md="3">
                              <v-select
                                  v-model="unit.roomTypeKey"
                                  label="Room Type"
                                  :items="roomTypeOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>

                                           <v-col cols="12" md="3">
                              <v-select
                                  v-model="unit.rateTypeKey"
                                  label="Rate Type"
                                  :items="rateTypeOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>

                                           <v-col cols="12" md="1">
                              <v-select
                                  v-model="unit.guests.adults"
                                  label="Adults"
                                  :items="adultGuestOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>
                                           <v-col cols="12" md="1">
                              <v-select
                                  v-model="unit.guests.olderChildren"
                                  label="Older Children"
                                  :items="olderChildrenGuestOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>
                                           <v-col cols="12" md="1">
                              <v-select
                                  v-model="unit.guests.youngChildren"
                                  label="Young Children"
                                  :items="youngChildrenGuestOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>
                                           <v-col cols="12" md="1">
                              <v-select
                                  v-model="unit.guests.babies"
                                  label="Babies"
                                  :items="babiesGuestOptions"
                                  :disabled="unit.shouldDelete"
                                  autocomplete
                               ></v-select>
                                           </v-col>

                                           <v-col cols="12" md="1">
                                               <v-checkbox v-model="unit.shouldDelete" label="Remove"></v-checkbox>
                                           </v-col>

                                           <v-col cols="12" md="2">
                                               <b>Quote Total:</b> {{ unit.quoteTotal }}{{ reservation.hotel.currency.currency_code }}
                                               <!--
                                               <v-text-field v-model="unit.quoteTotal"
                                                             :disabled="unit.shouldDelete"
                                                             label="Quote Total"></v-text-field>
                                               -->
                                           </v-col>
                                           <v-col cols="12" md="2">
                                               <b>Commission:</b> {{ unit.commission }}{{ reservation.hotel.currency.currency_code }}
                                               <!--
                                               <v-text-field v-model="unit.commission" 
                                                             :disabled="unit.shouldDelete"
                                                             label="Commission"></v-text-field>
                                               -->
                                           </v-col>
                                           <v-col cols="12" md="2">
                                               <v-checkbox v-model="unit.isAlternative" 
                                                           :disabled="unit.shouldDelete"
                                                           label="Is Alternative"></v-checkbox>
                                           </v-col>
                                           <v-col cols="12" md="2">
                                               <v-checkbox v-model="unit.isIndicative" 
                                                           :disabled="unit.shouldDelete"
                                                           label="Is Indicative"></v-checkbox>
                                           </v-col>

                                            <v-col cols="12">
                                                <h3>Policies</h3>
                                            </v-col>
                                            <v-col cols="12">
                                                <label>Payment Policy</label>
                                                <textarea v-model="unit.paymentPolicyText"
                                                           :disabled="unit.shouldDelete"></textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <h3>Additional Fees and Taxes</h3>
                                            </v-col>
                                            <v-col cols="12">
                                               <b>Note:</b> Unit specific taxes and additional fees are not yet supported
                                            </v-col>
                                          </v-layout>
                                         </fieldset>
                                       </div>
                                   </v-col>

                                   <v-col cols="12">
                                       <v-btn v-on:click="addUnit"><v-icon>add</v-icon> Add Room</v-btn>
                                   </v-col>
                                   
                              </v-layout>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-btn class="" 
                              v-on:click="cancel"
                              title="Cancel without changes">Cancel</v-btn>
                          <v-btn class="ies-green" 
                              title="Save the changes to the reservation"
                              v-on:click="saveChanges">Save</v-btn>
                      </v-card-actions>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    /**
     * A Vue component dedicated to letting the user update the quote for a reservation
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-change-rooms-rates',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                roomTypes: [],
                rateTypes: [],
                roomTypeOptions: [],
                rateTypeOptions: [],
                units: [],

                // Todo - remove these in preference of having a set of guest options per room type?
                adultGuestOptions: [],
                olderChildrenGuestOptions: [],
                youngChildrenGuestOptions: [],
                babiesGuestOptions: [],
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListeners() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },
            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    this.getRoomTypes();
                    this.getRateTypes();

                    this.units = [];
                    this.reservation.units.forEach(function(unit){
                        var thisUnit = {"ID":null, "reservationKey":this.reservation.reservation_key, "roomTypeKey":null, "rateTypeKey":null, "guests": {"babies":0, "youngChildren": 0, "olderChildren":0, "adults": 0}, "quoteTotal": 0.0, "commission": 0.0, "isIndicative":false, "isAlternative": false, "shouldDelete":false, "paymentPolicyText":""};

                        // The basics
                        thisUnit.ID = unit.reservation_unit_key;
                        thisUnit.reservationKey = unit.reservation_key;
                        thisUnit.roomTypeKey = unit.hotel_room_key;
                        thisUnit.rateTypeKey = unit.rate_type_key;
                        thisUnit.isAlternative = unit.is_alternative;
                        thisUnit.isIndicative = unit.is_indicative;

                        // Guests
                        thisUnit.guests.adults = unit.occ_adults;
                        thisUnit.guests.olderChildren = unit.occ_oldchildren;
                        thisUnit.guests.youngChildren = unit.occ_children;
                        thisUnit.guests.babies = unit.occ_babies;

                        // Money
                        thisUnit.commission = unit.commission;
                        thisUnit.commissionOverallPercentage = 0;// @todo this is actually an overall value from its individual unit dates
                        thisUnit.quoteTotal = unit.total;

                        // Policies
                        thisUnit.paymentPolicyText = unit.policy_payment_text;

                        this.units.push(thisUnit);
                    }
                    .bind(this));
                    
                }.bind(this));
            },
            addUnit:function(){
                var thisUnit = {"ID":null, "reservationKey":this.reservation.reservation_key, "roomTypeKey":null, "rateTypeKey":null, "guests": {"babies":0, "youngChildren": 0, "olderChildren":0, "adults": 0}, "quoteTotal": 0.0, "commission": 0.0, "isAlternative":false, "isIndicative":false, "shouldDelete":false, "paymentPolicyText":""};
                this.units.push(thisUnit);
            },

            getRoomTypes:function(){
                var self = this;
                axios.get('/api/hotel/' + this.reservation.hotel_key + '/room-types')
                .then(function(response){
                    this.roomTypes = response.data;
                    this.roomTypes.forEach(function(roomType){
                        this.roomTypeOptions.push({ text: (!roomType.is_online ? "✖ " : "") + roomType.name + (!roomType.is_online ? " (offline)" : ""), value: roomType.hotel_room_key });
                    }.bind(this));
                }.bind(this));
            },

            getRateTypes: function(){
                var self = this;
                axios.get('/api/hotel/' + this.reservation.hotel_key + '/rate-types')
                .then(function(response){
                    this.rateTypes = response.data;
                    this.rateTypes.forEach(function(rateType){
                        this.rateTypeOptions.push({ text: (!rateType.is_enabled ? "✖ " : "") + rateType.name + (!rateType.is_enabled ? " (offline)" : ""), value: rateType.rate_type_key });
                    }.bind(this));
                }.bind(this));
            },

            /**
             * Push the changes up to the server
             */
            saveChanges(){
                var params = {
                    units: this.units
                };
                axios.post('/api/reservation/' + this.reservationkey + '/set-rooms-rates', params)
                .then(function(response){
                    alert("Rooms updated, please check the prices per date");
                    EventBus.$emit('Reservation Administration: Reservation changed', {'reservationKey': this.reservationkey});
                    EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'changePrices'});
                }.bind(this));
            },
            cancel(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
            },
        },
        
        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
            this.setUpEventListeners();

            // To do  - move this to be based on acceptable numbers of guest types per room type?
            for(var index=0; index<10; index++){
                this.adultGuestOptions.push({"text":index, "value":index});
            }
            for(var index=0; index<10; index++){
                this.olderChildrenGuestOptions.push({"text":index, "value":index});
            }
            for(var index=0; index<10; index++){
                this.youngChildrenGuestOptions.push({"text":index, "value":index});
            }
            for(var index=0; index<10; index++){
                this.babiesGuestOptions.push({"text":index, "value":index});
            }
        },

        computed: {
            commissionLabel(){
                return "Commission (" + this.reservation.hotel.currency.currency_code + ")";
            },
            quoteTotalLabel(){
                return "Total Quote (" + this.reservation.hotel.currency.currency_code + ")";
            }
        }
    }
</script>

